import { render } from "./LoremsupportLogoIcon.vue?vue&type=template&id=6f121b7f"
const script = {}

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__